import { useTheme } from '@mui/material';

import type { IAccordionData } from '@rumblefish/ui/src/components/Rumblefish23Theme/Accordion/CustomizedAccordion.types';

export const faqData = {
  mainText: `FAQ`,
  description: `Beautifully designed digital products with Rumble Fish`,
};

export const useAccordionData = (): IAccordionData[] => {
  const theme = useTheme();
  return [
    {
      title: 'Q: Why are prototyping and wireframing important for my project?',
      description: `
        A: Prototyping and wireframing are essential because they allow us to visualize your product’s structure, flow, and functionality before development begins. This early-stage design helps identify potential issues, gather feedback, and make adjustments without costly revisions later. It also ensures that everyone involved in the project has a clear understanding of the final product.
      `,
      gradientOnFocus: theme.mixins.greenGradient?.background as string,
    },

    {
      title: 'Q: What’s the difference between UX and UI design?',
      description: `
        A: UX (User Experience) design focuses on how a product works and how users interact with it. It’s all about functionality, usability, and user flow. UI (User Interface) design, on the other hand, is about how the product looks, including visual elements like color schemes, typography, and layouts. Together, they create a cohesive experience where the product is both easy to use and visually appealing.
       `,
      gradientOnFocus: theme.mixins.blueGradient?.background as string,
    },
    {
      title: 'Q: What does mobile-first design mean, and why is it important?',
      description: `
        A: Mobile-first design means starting the design process with mobile devices in mind, ensuring that your product works seamlessly on smaller screens before adapting it for larger screens. This approach is important because mobile usage continues to grow, and it ensures your app or website performs well for the vast majority of users who access it from smartphones or tablets.
      `,
      gradientOnFocus: theme.mixins.violetGradient?.background as string,
    },
    {
      title:
        'Q: How do you ensure a responsive design across different devices?',
      description: `
       At Rumble Fish, we use a combination of flexible grids, fluid images, and media queries to ensure your design adapts perfectly across all screen sizes. We test your product on various devices and resolutions to ensure that it looks and functions beautifully on mobile, tablet, and desktop. This guarantees a seamless experience for all users, regardless of the device they’re using.
      `,
      gradientOnFocus: theme.mixins.purpleGradient?.background as string,
    },
    {
      title: 'Q: How long does the UX/UI design process take?',
      description: `
       The timeline for UX/UI design depends on the complexity and scope of your project. Typically, smaller projects may take a few weeks, while larger, more intricate designs can take several months. At Rumble Fish, we provide clear milestones and regular updates to ensure transparency throughout the design process.
      `,
      gradientOnFocus: theme.mixins.purpleGradient?.background as string,
    },
    {
      title: 'Q: How do you ensure that your designs align with my brand?',
      description: `
       We begin by thoroughly understanding your brand’s values, target audience, and overall goals. Our design team works closely with you, incorporating your feedback at every stage to ensure the final design not only aligns with your brand identity but also enhances it. We aim for a cohesive look that resonates with your audience.
      `,
      gradientOnFocus: theme.mixins.purpleGradient?.background as string,
    },
  ];
};
